<template>
  <div>
    <div v-if="centerId && periodItemId">
      <info v-if="type==='1'" :center-id="centerId" @typeChange="typeChange" :periodItemId="periodItemId">
        <template slot="periodItemId">
          <a-select
            placeholder="请选择"
            style="width: 200px"
            v-model="periodItemId"
          >
            <a-select-option :value="item.id"  v-for="item in periodItemList">{{item.name}}</a-select-option>
          </a-select>
        </template>
      </info>
      <center-info v-else-if="type==='2'" @change="centerIdChange" :periodItemId="periodItemId"  >
        <template slot="periodItemId2">
          <a-select
            placeholder="请选择"
            style="width: 200px"
            v-model="periodItemId"
          >
            <a-select-option :value="item.id"  v-for="item in periodItemList">{{item.name}}</a-select-option>
          </a-select>
        </template>
      </center-info>
      <item v-else @typeChange="typeChange" :center-id="centerId" :periodItemId="periodItemId"></item>
    </div>
  </div>
</template>

<script>
  import Info from './baselineFinish/Info'
  import CenterInfo from './baselineFinish/Center'
  import Item from './baselineFinish/Item'
  import {  mapGetters } from 'vuex'
  import { getAction } from '@/api/manage'
  import {CACHE_PROJECT_ID} from '@/constants/project'

  import Vue from 'vue'
  export default {
    name: 'BaselineFinish',
    components: { Info,CenterInfo,Item },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        type:'1',
        centerId:'',
        periodItemId:'',
        periodItemList:[]
      }
    },
    props:{

    },
    mounted(){
      this.centerIdChange(this.userInfo().centerId)
      getAction('/project/projectPeriodItem/list',{projectId:this.projectId}).then(res=>{
        if(res.success){
          this.periodItemList = res.result
          if(res.result.length>0){
            this.periodItemId = res.result[0].id
          }
        }
      })
    },
    methods:{
      ...mapGetters(["userInfo"]),
      centerIdChange(centerId){
        this.centerId = centerId
        this.typeChange('1')
      },
      typeChange(type){
        this.type=type
      },
      periodItemIdChange(periodItemId){
        this.periodItemId = periodItemId
      }
    }
  }
</script>

<style scoped>

</style>